import React from 'react';
import { syncImages, resetErrors } from '../../modules/images';
import withRouter from 'with-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ItemsList from '../../components/ItemsList';
import ItemsListSkeleton from '../../components/ItemsListSkeleton';
import EmptyView from '../../components/EmptyView';
import LoadingIndicator from '../../components/LoadingIndicator';
import Alert from '@mui/material/Alert';
import { withTranslation } from 'react-i18next';

class Images extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      images: [],
      errorLockCollapse: false
    }
  }

  componentDidMount() {
    this.props.syncImages(this.props.themes.edit_theme, this.props.editLanguage)
  }

  componentWillReceiveProps(newProps) {
    const currentLanguage = this.props.editLanguage;
    const newLanguage = newProps.editLanguage;
    if(currentLanguage != newLanguage) {
      this.props.syncImages(this.props.themes.edit_theme, newLanguage)
      return
    }

    const currentTheme = this.props.themes.edit_theme;
    const newTheme = newProps.themes.edit_theme;
    if(currentTheme != newTheme) {
      this.props.syncImages(newTheme, this.props.editLanguage)
      return
    }

    if(this.props.images.sync_images_pending === true && newProps.images.sync_images_pending === false) {
      const newImages = [];
      newProps.images.images.forEach(image => {
        newImages.push({
          id: image.id,
          title: image.name,
          type: image.type,
          fields: [{
            id: 'image',
            type: 'image',
            source: image.source.url,
            target: image.target.url || ''
          }]
        })
      })

      this.setState({images:newImages});
    }
  }

  onSave = items => {
  }

  render() {
    const { t } = this.props

    if(this.props.images.sync_images_pending === true || (this.props.images.error && this.props.images.error.level === 0)) {
      return <React.Fragment>
        <Typography variant="h4" gutterBottom component="h2">
          {t('pages.images.title')}
        </Typography>
        <Divider className="divider-white" />
        <ItemsListSkeleton rows="10"/>
        <LoadingIndicator
          pending={this.props.images.sync_images_pending}
          progress={this.props.images.progress}
          error={this.props.images.error}
        />
      </React.Fragment>  
    }

    return <React.Fragment>
      <Typography variant="h4" gutterBottom component="h2">
        {t('pages.images.title')}
      </Typography>
      <Divider className="divider-white" />
      <Alert severity="info">
        {t('pages.images.customContentsHint')}
      </Alert>
      <EmptyView
        title={t('pages.images.noContent')}
      />
      
      {false && 
        <ItemsList 
          type="page"
          pagination={true}
          isPending={false}
          isSaving={false}
          onSave={this.onSave}
          data={this.state.images}
          error={this.props.images.error}
          errorLockCollapse={this.state.errorLockCollapse}
          emptyMessage={
            <EmptyView
              title="No images found in /assets folder"
            />
          }
        />
      }
      <LoadingIndicator
        pending={this.props.images.sync_images_pending}
        progress={this.props.images.progress}
        error={this.props.images.error}
        onErrorCancel={this.props.resetErrors}
        onErrorRetry={() => {
          this.setState({ errorLockCollapse: true }, () => {
            this.setState({ errorLockCollapse: false });
          });
        }}
      />
    </React.Fragment> 
  }
}

const mapStateToProps = ({ images, shop, themes }) => ({
  images: images,
  editLanguage: shop.shop.edit_language,
  themes: themes
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      syncImages,
      resetErrors
    },
    dispatch
  )

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Images)))